<template>
  <div>
    <header class="navbar">
      <img src="../assets/pocketlegal_logo.png" alt="PocketLegal">
        <div id="username" class="c-hand">
          <avatar :user="user" class="headerAvatar"></avatar>
          {{user.profile.firstname}} {{user.profile.lastname}}
          <span class="chevron"></span>
          <div class="usernameMenu">
           <ul>
            <li>
              <router-link to="/profile">
                <i class="fa fa-cog" aria-hidden="true"></i>Edit Profile
              </router-link>
            </li>
            <li class="logout c-hand" @click="logout">
              <i class="fa fa-sign-out" aria-hidden="true"></i>Logout
            </li>
          </ul>
        </div>
        </div>

      <div id="sidebar-toggle" @click="toggleSidebar">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
    </header>
      <h1>{{title}}</h1>
  </div>
</template>

<script>
import utils from '@/components/utils'
import avatar from '@/components/users/avatar'

export default {
  name: 'header',
  components: { avatar: avatar },
  mixins: [utils],
  computed: {
    title () {
      return this.$root.$data.pageTitle
    },
    user () {
      return this.$root.$data.user
    }
  },
  methods: {
    logout () {
      utils.methods.logout(this)
    },
    toggleSidebar () {
      this.$root.$data.showSidebar = !this.$root.$data.showSidebar
    }
  }
}
</script>

<style scoped>
header {
  background-color: #fff;
  height: 48px;
  position: fixed;
  top: 0;
  left: 216px;
  width: calc(100% - 216px);
  z-index: 10;
  border-bottom: 1px solid #dadada
}
header img {
  display: none;
}
h1 {
  margin: 64px 0 0 243px;
}
#sidebar-toggle {
  z-index: 9;
  width: 30px;
  height: 45px;
  position: relative;
  top: 13px;
  right: 0em;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
  display: none;
}
#sidebar-toggle span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #222;
  border-radius: 0px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}
#sidebar-toggle span:nth-child(1) {
    top: 0px;
}
#sidebar-toggle span:nth-child(2) {
    top: 10px;
}
#sidebar-toggle span:nth-child(3) {
    top: 20px;
}
#username {
  margin:0 2em 0 1em;
  padding: 10px 16px 10px 10px;
  position: relative;
  color: inherit
}
.headerAvatar {
  float: left;
  padding: 0 1em 0 0
}
.chevron:before {
  border-style: solid;
  border-width: 1px 1px 0 0;
  content: '';
  display: inline-block;
  height: 0.45em;
  left: 0.15em;
  position: relative;
  top: 0.15em;
  transform: rotate(-45deg);
  vertical-align: top;
  width: 0.45em;
}
.chevron:before {
  top: 6px;
  transform: rotate(135deg);
}
.usernameMenu {
  display: none;
}
#username:hover .usernameMenu {
  display: block;
  position: absolute;
  top: 0px;
  left: -13px;
  width: 100%;
  padding: 32px 0 0 0 
}
.usernameMenu ul {
  box-shadow: 0px 4px 15px #000;
  background: #fff;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}
.usernameMenu ul li {
  list-style-type: none;
  padding: 0.6em 1em;
  border-bottom: 1px solid #dadada;
  margin: 0;
  color: #222
}
.usernameMenu ul li a {
  text-decoration: none!important;
  color: #222!important;
}
.usernameMenu ul li i {
  padding: 0 0.6em 0 0
}
.usernameMenu ul li:hover {
  background-color: #f5f6f9;
  color: #222!important
}
ul.usernameMenu li i {
  padding: 0 1em 0 0
}
.logout {
  color: #fff;
  cursor: pointer;
}
.logout:hover {
  color: #f1f1f1
}
/* for-phone-only */
@media (max-width: 599px) { 
  h1 {
    margin: 64px 5% 0 5%;
  }
  #sidebar-toggle {
    display: block
  }
  #username {
    display: none
  }
  header {
    width: 100%;
    left:0
  }
  header img {
    height: 26px;
    width: auto;
    margin: 13px 0 0 0;
    position: absolute;
    left: 5%;
    display: block
  }
  .navbar {
    justify-content: flex-end;
    padding: 0 5%;
  }
}
@media print {
  header {
    display: none
  }
  h1 {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?365d220e